import { AfterViewInit, Component, HostListener, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FcpModalService } from 'fc-ui-components';
import { ModalService } from 'services';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { Branch } from 'models';
import { FormControl, FormGroup } from '@angular/forms';
import { AutoUnsubscribe } from 'helpers';
import * as _ from 'lodash';
import { DropdownTreeItem, ModalConfig } from 'fc-ui-components';
import { map } from 'rxjs/operators';
import { MediaBreakpoint } from 'app/components/responsive-wrapper/constants';
import { StoreSelectorService } from 'app/b2b-order/services/store-selector/store-selector.service';
import { StoreService } from 'app/b2b-order/services/store.service';

@AutoUnsubscribe
@Component({
    selector: 'fc-choose-single-store-modal',
    templateUrl: './single-store-modal.component.html',
    styleUrls: ['./single-store-modal.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SingleStoreModalComponent implements OnInit, AfterViewInit, OnDestroy {
    stores: Observable<DropdownTreeItem<Branch>[]>;
    selectStoreForm: FormGroup<StoreForm>;
    onModalClosedSubscription: Subscription;
    @Input() modalId?: string;
    modalConfig: ModalConfig;
    public displayMode: DisplayMode = DisplayMode.Desktop;
    modalTitle = 'ORDER.SELECT_SINGLE_STORE_MODAL.ADD_ITEMS_TO';
    isMulti = false;

    constructor(
        public fcpModalService: FcpModalService,
        public storeService: StoreService,
        public storeSelectorService: StoreSelectorService,
        public modalService: ModalService
    ) {}

    ngOnInit() {
        this.storeService.fetchStoresObservable();
        this.stores = combineLatest([this.storeService.storeDropdown, this.storeSelectorService.selectedStores]).pipe(
            map(([stores, selectedStores]) => stores.filter((store) => _.includes(selectedStores, store.value)))
        );
        this.selectStoreForm = new FormGroup({
            store: new FormControl(),
            stores: new FormControl([])
        });

        this.modalConfig = {
            id: this.modalId,
            disableClose: false
        };
    }

    ngOnDestroy(): void {
        this.modalService.remove(this.modalId);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: { target: { innerWidth: number } }) {
        this.setDisplayMode(event.target.innerWidth);
    }

    ngAfterViewInit() {
        this.setDisplayMode(window.innerWidth);
    }

    hideModal() {
        this.selectStoreForm.setValue({
            store: null,
            stores: []
        });
        if (this.fcpModalService.isModalOpen(this.modalId)) {
            this.fcpModalService.close(this.modalId);
        }
    }

    cancelSave() {
        this.hideModal();
    }

    emitSelectedStore() {
        const store = this.selectStoreForm.get('store').value;
        this.storeSelectorService.updateSelectedStore(store.value);
        this.hideModal();
    }

    public get DisplayMode() {
        return DisplayMode;
    }

    public get modalSize(): string {
        return this.displayMode === DisplayMode.Desktop ? 'small' : 'mobile';
    }

    public get selectedStores() {
        if (this.isMulti) {
            return this.selectStoreForm.get('stores').value.map((store) => ({ text: store.label, value: store.value }));
        } else return [];
    }

    public onRemoveStore(store: { text: string; value: Branch }) {
        this.selectStoreForm
            .get('stores')
            .setValue(this.selectStoreForm.get('stores').value.filter((s) => s.value !== store.value));
    }

    public get storeDropdownInvalid() {
        return false;
    }

    private setDisplayMode(width: number) {
        if (width < MediaBreakpoint.Desktop) this.displayMode = DisplayMode.Mobile;
        else this.displayMode = DisplayMode.Desktop;
    }
}

export enum DisplayMode {
    Desktop = 'desktop',
    Mobile = 'mobile'
}

interface StoreForm {
    store: FormControl<DropdownTreeItem<Branch>>;
    stores: FormControl<DropdownTreeItem<Branch>[]>;
}

export const selectStoreModalId = 'select-one-store-modal';
